import HoverBoxAnchor from "../UI/hoverBox/HoverBoxAnchor";
import { ReactComponent as InfoIcon } from "../../assets/icons/Info.svg";

const ContingencySectionHeader = ({
  title,
  description,
}: {
  title: string;
  description: string;
}) => (
  <div className="flex items-center gap-[var(--spacing-sm)]">
    <h3 style={{ font: "var(--font-h3)" }}>{title}</h3>
    <HoverBoxAnchor tooltipText={description}>
      <InfoIcon width={16} height={16} />
    </HoverBoxAnchor>
  </div>
);

export default ContingencySectionHeader;
